const TemplateColors = {
  FIELD_BACKGROUND: 'fieldBackgroundColor',
  TEXT_FONT: 'textFontColor',
  HEADER_FONT: 'headerFontColor',
  HEADER_BACKGROUND: 'headerBackgroundColor',
};

export default TemplateColors;
